export default "__VITE_ASSET__C0EJQ08w__"